"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'golden',
    name: 'Golden',
    background_color: '#ff9300',
    background_image: 'https://assets.raydiant.com/images/golden.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/golden-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/AbrilFatface-Regular.woff',
    heading_text_color: '#051727',
    heading_2_font: 'https://fonts.raydiant.com/Oswald-Regular.woff',
    heading_2_text_color: '#f9f613',
    body_font: 'https://fonts.raydiant.com/Oswald-Regular.woff',
    body_text_color: '#051727',
    border_color: '#f9f613',
};
//# sourceMappingURL=golden.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/golden.js